import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'pace-pch-alert',
    templateUrl: './pch-alert.component.html',
    standalone: false,
})
export class PCHAlertComponent {
    public openPCHDurationModel: Subject<void> = new Subject<void>();

    public constructor(private readonly modalInstance: BsModalRef) {}

    public closeModal(): void {
        this.modalInstance.hide();
    }

    public onRequest(): void {
        this.openPCHDurationModel.next();
        this.closeModal();
    }
}
